/**
 * Post Spotlights 상수
 * @description 서버 컴포넌트와 브라우저 훅이 함께 쓰는 값이라 **`"use client"` 가 없는 자리**에
 *   둔다. 클라이언트 모듈의 export 를 서버 컴포넌트가 가져오면 Next 가 값이 아니라 클라이언트
 *   참조로 바꿔 놓아서, 숫자를 기대한 자리에 "부르면 던지는 함수" 가 들어간다.
 */

/** 한 번에 받아 오는 카드 수 */
export const SPOTLIGHT_PAGE_SIZE = 20;
